<template>
    <div>
        <setting-with-text
            v-if="hasCollectiveHdBox"
            :title="lang('HD-box','HD box')"
        >
            <div class="font-bold text-sm text-neutral-darker lg:w-2/5">
                <div class="bg-neutral-lighter rounded-lg py-md px-lg flex items-center justify-start">
                    <div class="text-lg text-success mr-lg">
                        <font-awesome-icon icon="check-circle" />
                    </div>
                    <div class="max-w-xs text-sm font-semibold">
                        <span>{{ lang('Du har redan en HD-box från Ownit','You already own a HD box from ownit') }}!</span>
                    </div>
                </div>
            </div>
        </setting-with-text>

        <hardware-radio-options
            v-else-if="localHdBoxes.length > 0"
            v-model="localSelectedHdBoxId"
            :title="lang('Hur vill du se tv?', 'How do you want to watch tv?')"
            :options="localHdBoxes"
        />

        <setting-with-checkbox
            v-if="shouldShowHardDriveForHdBox"
            v-model="hardDriveSelected"
            :options="[hardDriveForHdBox]"
            :title="lang('Inspelningsbar HD-box','Recordable HD box')"
        />
    </div>
</template>

<script>
import SettingWithText from '../Settings/SettingWithText.vue';
import HardwareRadioOptions from './HardwareRadioOptions.vue';

export default {
    components: { HardwareRadioOptions, SettingWithText },
    model: {
        prop: 'selected',
        event: 'input',
    },
    props: {
        hdBoxes: {
            type: Array,
            required: true,
        },
        selected: {
            type: [Object, null],
            required: false,
            default: null,
        },
        allowNoneSelection: {
            type: Boolean,
            default: true,
        },
        hasCollectiveHdBox: {
            type: Boolean,
            default: false,
        },
        hardDriveForHdBox: {
            type: [Object, null],
            required: false,
            default: null,
        },
    },
    data() {
        return {
            localSelectedHdBoxId: null,
            localHdBoxes: [],
            hardDriveSelected: false,
        };
    },
    computed: {
        localSelected: {
            get() {
                return this.selected;
            },
            set(hdBox) {
                this.$emit('input', hdBox);
            },
        },
        shouldShowHardDriveForHdBox() {
            if (! this.localSelected) {
                return null;
            }

            return !! (this.hardDriveForHdBox && (this.hasCollectiveHdBox || (this.selectedHdBox && ! this.selectedHdBox.has_hard_drive)));
        },
    },
    watch: {
        localSelectedHdBoxId(newHdBoxId) {
            this.localSelected = this.hdBoxes.find(hdBox => hdBox.value === newHdBoxId);
        },
        hardDriveSelected(isSelected) {
            this.$emit('hard-drive-updated', isSelected ? this.hardDriveForHdBox : null);
        },
        hdBoxes() {
            this.setup();
        },
    },
    mounted() {
        this.setup();
    },
    methods: {
        setup() {
            this.localHdBoxes = [];

            this.hdBoxes.forEach(hdBox => {
                hdBox['name'] = 'hd_box';

                this.localHdBoxes.push(hdBox);
            });

            if (this.allowNoneSelection) {
                this.localHdBoxes.push({
                    value: 'no_hd_box',
                    name: 'hd_box',
                    placeholder: this.translation('tv_configurator_only_play_title'),
                    description: this.translation('tv_configurator_only_play_short_description'),
                });
            }

            this.localSelectedHdBoxId = this.localHdBoxes[0].value;
        },
    },
};
</script>
